import { render, staticRenderFns } from "./tkPay.vue?vue&type=template&id=7916ef53&scoped=true&"
import script from "./tkPay.vue?vue&type=script&lang=js&"
export * from "./tkPay.vue?vue&type=script&lang=js&"
import style0 from "./tkPay.vue?vue&type=style&index=0&id=7916ef53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7916ef53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VContainer,VDivider,VFlex,VLayout})
